export default {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
};
